import React from "react";
import toast from "react-hot-toast";
import { Button, CloseButton, Row, Col } from "react-bootstrap";

const TOAST_CONFIG = {
  error: {
    duration: Infinity,
    style: {
      background: "#363636",
      color: "#fff",
      minWidth: "300px",
      padding: "16px",
    },
  },
  success: {
    duration: 4000,
    style: {
      minWidth: "300px",
      padding: "16px",
    },
  },
};

const toastTemplate = (type, title, message, color) => {
  toast(
    (t) => (
      <div>
        <Row>
          <Col className="pb-3" style={{ color: color }}>
            <strong>{title}</strong>
          </Col>
          <Col className="rightText">
            <CloseButton
              variant={type === "error" ? "white" : undefined}
              onClick={() => toast.dismiss(t.id)}
            ></CloseButton>
          </Col>
        </Row>
        <Row>
          <Col>{message}</Col>
        </Row>
        <Row className="pt-3 centerText">
          <Col></Col>
        </Row>
        <Row className="pt-3 text-center">
          <Col>
            <Button
              variant={type === "error" ? "danger" : "success"}
              onClick={() => toast.dismiss(t.id)}
            >
              Dismiss
            </Button>
          </Col>
        </Row>
      </div>
    ),
    TOAST_CONFIG[type]
  );
};

export const tError = (message) => {
  return toastTemplate("error", "Error", message, "red");
};

export const tSuccess = (message) => {
  return toastTemplate("success", "Success", message, "green");
};
